import React , {useEffect , useState} from 'react';
import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";
import './App.css';
import NumberFormat from 'react-number-format';
import Columns from "react-columns";
import Form from "react-bootstrap/Form";


function App() {
  
  const [latest , setLatest] = useState([]);
  const [results , setResults] = useState([]);
  const [searchCountries, setSearchCountries] = useState([]);
  var queries = [{
    columns: 2,
    query: 'min-width: 500px'
  }, {
    columns: 3,
    query: 'min-width: 1000px'
  }];
  

 useEffect(() => {
    axios
        .all([axios.get("https://corona.lmao.ninja/v2/all"), axios.get("https://corona.lmao.ninja/v2/countries?sort=country")])

    .then(responseArr =>  {
    setLatest(responseArr[0].data);
    setResults(responseArr[1].data);
    
   })
  .catch(error => {
    console.log(error)
  });
}, [results]);
  
  const date = new Date(parseInt(latest.updated));
  const lastUpdated = date.toString();
 const reversed = [].concat(results).reverse();

 const filterCountries = reversed.filter(item => {
  let itemCountry = item.country;
  let itemCountryLower = itemCountry.toLowerCase();
 
 
return searchCountries != "" ? itemCountryLower.includes(searchCountries) : item;

});

  const countries = filterCountries.map(data => {
    
    return (
      
      <Card bg="light" text="dark"  className="text-center" style={{margin:"10px"}} key={data.country}>
    <Card.Img variant="top" src={data.countryInfo.flag}/>
    <Card.Body style={{padding:"1vh 4rem"}}>
      <Card.Title style={{marginBottom:"30px"}}>{data.country}</Card.Title>
       
      <Card.Text>Cases:{" "} 
       <NumberFormat value={data.cases} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
       <Card.Text>Deaths:{" "} 
       <NumberFormat value={data.deaths} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
       <Card.Text>Recovered:{" "} 
       <NumberFormat value={data.recovered} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
       <Card.Text>Today's Cases:{" "} 
       <NumberFormat value={data.todayCases} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
       <Card.Text>Today's Deaths:{" "} 
       <NumberFormat value={data.todayDeaths} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
       <Card.Text>Active:{" "}  
       <NumberFormat value={data.active} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
       <Card.Text>Critical:{" "} 
       <NumberFormat value={data.critical} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
      
    </Card.Body>
   </Card>
   

  );
  });


  return (
    <div className="App">
    <h1 style={{textAlign:"center", marginBottom:"20px"}}>COVID-19 Tracker</h1>
    <CardDeck style={{margin:"0px"}}>
  <Card bg="info" text="white" className="text-center" style={{margin:"10px"}}>
    
    <Card.Body>
      <Card.Title>Cases</Card.Title>
      <Card.Text>
       <NumberFormat value={latest.cases} displayType={'text'} thousandSeparator={true}/> 
      </Card.Text>
    </Card.Body>
    <Card.Footer>
      <small>{lastUpdated}</small>
    </Card.Footer>
  </Card>
  <Card bg="danger" text="white" className="text-center" style={{margin:"10px"}}>
   
    <Card.Body>
      <Card.Title>Deaths</Card.Title>
      <Card.Text>
         <NumberFormat value={latest.deaths} displayType={'text'} thousandSeparator={true}/>
      </Card.Text>
    </Card.Body>
    <Card.Footer>
      <small>{lastUpdated}</small>
    </Card.Footer>
  </Card>
  <Card bg="success" text="white" className="text-center" style={{margin:"10px"}}>
  
    <Card.Body>
      <Card.Title>Recovered</Card.Title>
      <Card.Text>
         <NumberFormat value={latest.recovered} displayType={'text'} thousandSeparator={true}/>
      </Card.Text>
    </Card.Body>
    <Card.Footer>
      <small>{lastUpdated}</small>
    </Card.Footer>
  </Card>
</CardDeck>
<Form style={{margin:"10px"}}>
  <Form.Group controlId="formGroupInput">
  <Form.Control type="text" 
  placeholder="Search a country..." 
   onChange={event => setSearchCountries(event.target.value.toLowerCase())}/>
  </Form.Group>
  
</Form>
   <Columns  queries={queries}>
    {countries}
    </Columns>


    </div>
  );
}

export default App;
